module.exports = __webpack_public_path__ + "img/icon_public_portal_maintenance.cdeca5a4.svg";